<div id="menuNav" class="navbar-collapse collapse"
     [ngClass]="{ show: isExpanded }">
  <ul class="navbar-nav  flex-grow" [routerLinkActive]="['bidit-nav-active']" [routerLinkActiveOptions]="{ exact: true }">
    <li [hidden]="hideQuoteTabs" class="nav-item bidit-nav-item">
      <a class="nav-link text-bidit-primary bg-white border"  (click)="toggle()"[routerLink]="['/customer']">
      <img src="assets/img/circle_images/customer_circle.png" /><span i18n>CUSTOMERS</span>
      <img class="float-right" src="assets/img/icons/menu-arrow-right.png"/></a>     
    </li>
    <li [hidden]="hideQuoteTabs" class="nav-item bidit-nav-item">
      <a class="nav-link text-bidit-primary bg-white border" (click)="toggle()"[routerLink]="['/lead']">
      <img src="assets/img/circle_images/leads_circle.png"><span i18n>LEADS</span>
      <img class="float-right" src="assets/img/icons/menu-arrow-right.png"/></a>
    </li>
    <li [hidden]="hideQuoteTabs" class="nav-item bidit-nav-item">
      <a class="nav-link text-bidit-primary bg-white border" (click)="toggle()"[routerLink]="['/quote']">
      <img src="assets/img/circle_images/quotes_circle.png" /><span i18n>QUOTES</span>
      <img class="float-right" src="assets/img/icons/menu-arrow-right.png" /></a>
    </li>
    <li [hidden]="hideJobTools" class="nav-item bidit-nav-item">
        <a class="nav-link text-bidit-primary bg-white border" (click)="toggle()" [routerLink]="['/job']">
            <img src="assets/img/circle_images/job_circle.png" /><span i18n>JOBS</span>
            <img class="float-right" src="assets/img/icons/menu-arrow-right.png" />
        </a>
    </li>
    <li [hidden]="hideJobTools" class="nav-item bidit-nav-item">
        <a class="nav-link text-bidit-primary bg-white border" (click)="toggle()" [routerLink]="['/workorder']">
            <img src="assets/img/circle_images/users_circle.png" /><span i18n>WORK ORDERS</span>
            <img class="float-right" src="assets/img/icons/menu-arrow-right.png" />
        </a>
    </li>
    <li class="nav-item bidit-nav-item">
      <a class="nav-link text-bidit-primary bg-white border" (click)="logout($event)">
      <img src="assets/img/mobile_menu_bar/logout.png" /><span i18n>Logout</span></a>
    </li>
  </ul>
</div>
<nav class="navbar  navbar-bidit-mobile navbar-dark navbar-toggleable-lg">
  <a routerLink="/">
    <img class="" alt="Home" src="assets/img/mobile_menu_bar/home.png" />
  </a>
  <a *ngIf="!hideJobTools" routerLink="/calendar">
      <img alt="Calendar" src="assets/img/mobile_menu_bar/calendar_mobile.png" />
  </a>
  <a *ngIf="!isIDIAdmin" routerLink="/contact">
    <img alt="Contact Us" src="assets/img/mobile_menu_bar/contact_us.png" />
  </a>
  <button class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target=".navbar-collapse"
          aria-label="Toggle navigation"
          (click)="toggle()">
    <span class="navbar-toggler-icon"></span>
  </button>
</nav>
